import { render, staticRenderFns } from "./SwiperBlog.vue?vue&type=template&id=5b7a627b&scoped=true&"
import script from "./SwiperBlog.vue?vue&type=script&lang=js&"
export * from "./SwiperBlog.vue?vue&type=script&lang=js&"
import style0 from "./SwiperBlog.vue?vue&type=style&index=0&id=5b7a627b&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b7a627b",
  null
  
)

export default component.exports